import { UserRoleEnum } from "@repo/schema";
import { useAuth } from "./useAuth";

/** True when the session is a super admin viewing an org they are not a member of (read-only) */
export const useIsReadOnly = () => {
  const { role } = useAuth();
  return role === UserRoleEnum.SUPER_ADMIN;
};
